import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QuestionsGroupApi } from "./QuestionsGroupApi";

const defaultState = {
    groups: [],
    isLoaded: false,
    isLoading: false
}
export const FetchQuestionsGroups = createAsyncThunk('eduquestions/usergroup', async () => {
    const questionGroups = await QuestionsGroupApi();
    return questionGroups;
});
const QuestionsGroupSlice = createSlice({
    name: 'QuestionsGroup',
    initialState : defaultState,
    extraReducers: (builder) => {
        builder
            .addCase(FetchQuestionsGroups.pending, (state) => {
                state.isLoading = true;
                state.isLoaded = false;
            })
            .addCase(FetchQuestionsGroups.fulfilled, (state, action) => {
                state.groups = action.payload;
                state.isLoading = false;
                state.isLoaded = true;
            })
            .addCase(FetchQuestionsGroups.rejected, (state) => {
                state.isLoading = false;
                state.isLoaded = true;
            });
           
    }
});
export const { QuestionsGroup } = QuestionsGroupSlice.actions;
export default QuestionsGroupSlice.reducer;